import { aiTypes } from "../action-types/ai.types";
import { AiActionType } from "../actions/ai.actions";
import { success } from "../helpers/action.helper";

export type AiState = {
  connectionString: string;
};

const initialState: AiState = {
    connectionString: "",
};

export default (state: AiState = initialState, action: AiActionType): AiState => {
  switch (action.type) {
    case success(aiTypes.GET_CONNECTIONSTRING):
      return {
        ...state,
          connectionString: action.payload,
      };
    default:
      return state;
  }
};
